/** 토글 묶음(open-questions B9). Figma 에는 아직 세트가 없다 — `FundPicker` · `EvaluationItemPicker` 의 공통 모양 */

/** 버튼 크기. xs = 토글 24 · 전체 버튼 2xs(24), sm = 토글 32 · 전체 버튼 xs(28) */
export const TOGGLE_GROUP_SIZES = ['xs', 'sm'] as const;
export type ToggleGroupSize = (typeof TOGGLE_GROUP_SIZES)[number];

/** 토글 버튼 한 개의 너비(size/button/*). hug = 글자에 맞춤 */
export const TOGGLE_GROUP_ITEM_WIDTHS = ['hug', 'xs', 'sm', 'md', 'lg', 'xl'] as const;
export type ToggleGroupItemWidth = (typeof TOGGLE_GROUP_ITEM_WIDTHS)[number];

export const ITEM_WIDTH_CLASS: Record<ToggleGroupItemWidth, string> = {
  hug: '',
  xs: 'w-(--size-button-xs)',
  sm: 'w-(--size-button-sm)',
  md: 'w-(--size-button-md)',
  lg: 'w-(--size-button-lg)',
  xl: 'w-(--size-button-xl)',
};

/** 전체 선택 버튼: 크기 · 너비(md 120) */
export const SELECT_ALL_BUTTON_SIZE = { xs: '2xs', sm: 'xs' } as const;

/** 머리말 줄과 버튼 목록 사이 간격: none 0 · sm 10 · md 16(기본) · lg 20 */
export const TOGGLE_GROUP_GAPS = ['none', 'sm', 'md', 'lg'] as const;
export type ToggleGroupGap = (typeof TOGGLE_GROUP_GAPS)[number];

export const GAP_CLASS: Record<ToggleGroupGap, string> = {
  none: 'gap-0',
  sm: 'gap-2-5',
  md: 'gap-4',
  lg: 'gap-5',
};
